var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHuevos = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11111 17C4.73611 17 2 14.2639 2 10.8889C2 7.51389 4.73611 2 8.11111 2C11.4861 2 14.2222 7.51389 14.2222 10.8889C14.2222 14.2639 11.4861 17 8.11111 17Z",
    fill: "#E68600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.8888C7 12.5138 9.73611 9.77771 13.1111 9.77771C16.4861 9.77771 22 12.5138 22 15.8888C22 19.2638 16.4861 21.9999 13.1111 21.9999C9.73611 21.9999 7 19.2638 7 15.8888Z",
    fill: "#FFBF00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHuevos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Huevos.a53b6ea4.svg";
export { ForwardRef as ReactComponent };